



























































helpers = require('../../helpers.coffee')

view_model = {
  components:
    notificationBell: require('./notifications/bell')
    notificationsPopup: require('./notifications/popup')
    voip: require('./header_actions/voip')
    email: require('./header_actions/email')
    changeAccount: require('./header_actions/change_account')

  data: ->
    current_user: Session.current_user
    groups: []
    tags: []
    users: []

  computed:
    show_change_account: ->
      @current_user.virtual_user_count > 1 || @current_user.isAdmin()

    load_user: ->
      @$store.getters.usersCount == 0

    load_tag: ->
      @$store.getters.tagsCount == 0

    change_to_new_ui: ->
      @current_user.extradata.change_to_new_ui

    to_help: ->
      'https://suporte.reev.co'

  methods:
    goToNewUi: ->
      Session.current_user.extradata['use_new_ui'] = true
      @usersResource.update(@updateUserSuccess, @handleApiErrors, Session.current_user)

    updateUserSuccess: (data, response) ->
      window.location = "#{process.env.NEW_URL_REEV}/auth/novo-reev?redirect=#{window.location.pathname.slice(1,)}"

    updateCurrentUser: ->
      @current_user = Session.current_user

    logout: ->
      Session.logout @logoutSuccess

    logoutSuccess: ->
      @$router.replace name: 'landing'

  mounted: ->
    @usersResource = new UsersResource()
    Tooltip.initialize()
}

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/header.vue